import React from 'react';
import styled, { keyframes } from 'styled-components';
import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const PageContainer = styled.div`
  background-color: #121212;
  color: #e0e0e0;
  min-height: 100vh;
  padding: 4rem 2rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  animation: ${fadeIn} 1s ease-out;
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.5rem;
  color: #ffffff;
  text-shadow: 0 0 10px rgba(255,255,255,0.1);
`;

const Section = styled.section`
  margin-bottom: 2.5rem;
  background-color: rgba(255,255,255,0.05);
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 8px rgba(0,0,0,0.15);
  }
`;

const SectionTitle = styled.h2`
  margin-bottom: 1.5rem;
  color: #4caf50;
  font-size: 1.8rem;
`;

const Paragraph = styled.p`
  line-height: 1.8;
  margin-bottom: 1rem;
  font-size: 1.1rem;
`;

const Highlight = styled.span`
  color: #ff6b6b;
  font-weight: bold;
`;

const TerminosYCondiciones = () => {

          const { pathname }  = useLocation()
      
          useEffect(() => {
            window.scrollTo(0, 0);
          }, [pathname]);

  return (
    <>
    <Header />
    <PageContainer>
      <ContentWrapper>
        <Title>Términos y Condiciones</Title>
        
        <Section>
          <SectionTitle>En General</SectionTitle>
          <Paragraph>
            Este sitio web es operado por Global Eco Business SAS. En todo el sitio, los
  términos "nosotros", "nos" y "nuestro" se refieren a <Highlight>Global Eco Business SAS</Highlight>.
  Global Eco Business SAS ofrece este sitio web Bicicletas JAVA Colombia, que
  incluye toda la información, herramientas y servicios disponibles para usted, el
  usuario, en este sitio, condicionando a la aceptación de todos los términos,
  condiciones, políticas y notificaciones aquí establecidos.
  Al visitar nuestro sitio y / o comprarnos algo, participa en nuestro "Servicio" y acepta
  estar sujeto a los siguientes términos y condiciones ("Términos de servicio",
  "Términos"), incluidos los términos y condiciones y políticas adicionales.
  referenciado en este documento y / o disponible por hipervínculo. Estos Términos
  de servicio se aplican a todos los usuarios del sitio, incluidos, entre otros, los
  usuarios que son navegadores, proveedores, clientes, comerciantes y / o
  contribuyentes de contenido.
  Lea estos Términos de servicio detenidamente antes de acceder o utilizar nuestro
  sitio web. Al acceder o utilizar cualquier parte del sitio, acepta estar sujeto a estos
  Términos de servicio. Si no está de acuerdo con todos los términos y condiciones
  de este acuerdo, no podrá acceder al sitio web ni utilizar ningún servicio. Si estos
  Términos de servicio se consideran una oferta, la aceptación se limita expresamente
  a estos Términos de servicio.
  Cualquier característica o herramienta nueva que se agregue a la tienda actual
  también estará sujeta a los Términos de servicio. Puede revisar la versión más
  actualizada de los Términos de servicio en cualquier momento en esta página. Nos
  reservamos el derecho de actualizar, cambiar o reemplazar cualquier parte de estos
  Términos de servicio mediante la publicación de actualizaciones y / o cambios en
  nuestro sitio web. Es su responsabilidad revisar esta página periódicamente para
  ver si hay cambios. Su uso continuo o acceso al sitio web después de la publicación
  de cualquier cambio constituye la aceptación de dichos cambios.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 1 - TÉRMINOS DE LA TIENDA EN LÍNEA</SectionTitle>
          <Paragraph>
          Al aceptar estos <Highlight>Términos de servicio</Highlight>, usted declara que tiene al menos la mayoría
          de edad y nos ha dado su consentimiento para permitir que cualquiera de sus
          dependientes menores de edad use este sitio.
          No puede usar nuestros productos para ningún propósito ilegal o no autorizado ni
          puede, en el uso del Servicio, violar las leyes de su jurisdicción (incluidas, entre
          otras, las leyes de derechos de autor).

          No debe transmitir gusanos o virus ni ningún código de naturaleza destructiva.
          Un incumplimiento o violación de cualquiera de los Términos resultará en la
          terminación inmediata de sus Servicios.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 2 - CONDICIONES GENERALES</SectionTitle>
          <Paragraph>
          Nos reservamos el derecho de rechazar el servicio a cualquier persona por cualquier
          motivo y en cualquier momento.
          Usted comprende que su contenido (sin incluir la información de la tarjeta de crédito)
          puede transferirse sin cifrar e implicar (a) transmisiones a través de varias redes; y
          (b) cambios para ajustarse y adaptarse a los requisitos técnicos de conexión de
          redes o dispositivos. La información de la tarjeta de crédito siempre se cifra durante
          la transferencia a través de redes.
          Usted acepta no reproducir, duplicar, copiar, vender, revender o explotar cualquier
          parte del Servicio, el uso del Servicio o el acceso al Servicio o cualquier contacto en
          el sitio web a través del cual se brinda el servicio, sin nuestro permiso expreso por
          escrito.
          Los títulos utilizados en este acuerdo se incluyen solo por conveniencia y no
          limitarán ni afectarán estos Términos.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 3 - EXACTITUD, INTEGRIDAD Y PUNTUALIDAD DE LA INFORMACIÓN</SectionTitle>
          <Paragraph>
          No somos responsables si la información disponible en este sitio no es precisa,
          completa o actual. El material de este sitio se proporciona solo para información
          general y no debe confiarse en él ni utilizarse como la única base para tomar
          decisiones sin consultar fuentes de información primarias, más precisas, más
          completas o más oportunas. Cualquier confianza en el material de este sitio es bajo
          su propio riesgo.
          Este sitio puede contener cierta información histórica. La información histórica,
          necesariamente, no es actual y se proporciona solo para su referencia. Nos
          reservamos el derecho de modificar el contenido de este sitio en cualquier momento,
          pero no tenemos la obligación de actualizar ninguna información en nuestro sitio.
          Acepta que es su responsabilidad controlar los cambios en nuestro sitio.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 4 - MODIFICACIONES AL SERVICIO Y PRECIOS</SectionTitle>
          <Paragraph>
          Los <Highlight>precios de nuestros productos</Highlight> están sujetos a cambios sin previo aviso.
          Nos reservamos el derecho en cualquier momento de modificar o descontinuar el
          Servicio (o cualquier parte o contenido de este) sin previo aviso en cualquier
          momento.
          No seremos responsables ante usted ni ante ningún tercero por ninguna
          modificación, cambio de precio, suspensión o interrupción del Servicio.
          </Paragraph>
        </Section>
        <Section>
          <SectionTitle>SECCIÓN 5 - PRODUCTOS O SERVICIOS (si corresponde)</SectionTitle>
          <Paragraph>
        Ciertos productos o servicios pueden estar disponibles <Highlight>exclusivamente en línea a
        través del sitio web</Highlight>. Estos productos o servicios pueden tener cantidades limitadas
        y están sujetos a devolución o cambio solo de acuerdo con nuestra Política de
        devolución.
        Hemos hecho todo lo posible para mostrar con la mayor precisión posible los colores
        e imágenes de nuestros productos que aparecen en la tienda. No podemos
        garantizar que la visualización de cualquier color en el monitor de su computadora
        sea precisa.
        Nos reservamos el derecho, pero no estamos obligados, a limitar las ventas de
        nuestros productos o servicios a cualquier persona, región geográfica o jurisdicción.
        Podemos ejercer este derecho caso por caso. Nos reservamos el derecho de limitar
        las cantidades de cualquier producto o servicio que ofrecemos. Todas las
        descripciones de los productos o los precios de los productos están sujetos a
        cambios en cualquier momento sin previo aviso, a nuestra entera discreción. Nos
        reservamos el derecho de descontinuar cualquier producto en cualquier momento.
        No garantizamos que la calidad de cualquier producto, servicio, información u otro
        material comprado u obtenido por usted cumpla con sus expectativas, o que
        cualquier error en el Servicio será corregido.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 6 - PRECISIÓN DE LA FACTURACIÓN Y LA INFORMACIÓN DE LA
          CUENTA</SectionTitle>
          <Paragraph>
          Nos reservamos el derecho a rechazar cualquier pedido que realice con nosotros.
          Podemos, a nuestro exclusivo criterio, limitar o cancelar las cantidades compradas
          por persona, por hogar o por pedido. Estas restricciones pueden incluir pedidos
          realizados por o bajo la misma cuenta de cliente, la misma tarjeta de crédito y / o
          pedidos que utilizan la misma dirección de facturación y / o envío. En el caso de que
          hagamos un cambio o cancelemos un pedido, podemos intentar notificarlo
          poniéndonos en contacto con el correo electrónico y / o la dirección de facturación /
          número de teléfono proporcionado en el momento en que se realizó el pedido. Nos
          reservamos el derecho de limitar o prohibir los pedidos que, a nuestro exclusivo
          criterio, parecen ser realizados por concesionarios, revendedores o distribuidores.
          Usted acepta proporcionar información de compra y cuenta actual, completa y
          precisa para todas las compras realizadas en nuestra tienda. Usted acepta
          actualizar de inmediato su cuenta y otra información, incluida su dirección de correo
          electrónico, números de tarjeta de crédito y fechas de vencimiento, para que
          podamos completar sus transacciones y comunicarnos con usted según sea
          necesario.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 7 - HERRAMIENTAS OPCIONALES</SectionTitle>
          <Paragraph>
          Es posible que le proporcionemos acceso a herramientas de terceros sobre las que
          no supervisamos ni tenemos control ni entrada.
          Usted reconoce y acepta que proporcionamos acceso a dichas herramientas "tal
          como están" y "según estén disponibles" sin garantías, representaciones o
          condiciones de ningún tipo y sin ningún respaldo. No tendremos ninguna
          responsabilidad derivada o relacionada con su uso de herramientas opcionales de
          terceros.
          Cualquier uso que haga de las herramientas opcionales que se ofrecen a través del
          sitio es bajo su propio riesgo y discreción, y debe asegurarse de estar familiarizado
          y aprobar los términos en los que las herramientas son proporcionadas por los
          proveedores de terceros relevantes.
          También podemos, en el futuro, ofrecer nuevos servicios y / o características a
          través del sitio web (incluido el lanzamiento de nuevas herramientas y recursos).
          Tales nuevas características y / o servicios también estarán sujetos a estos
          Términos de Servicio.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 8 - ENLACES DE TERCEROS</SectionTitle>
          <Paragraph>
          Cierto contenido, productos y servicios disponibles a través de nuestro Servicio
          pueden incluir materiales de terceros.
          Los enlaces de terceros en este sitio pueden dirigirlo a sitios web de terceros que
          no están afiliados a nosotros. No somos responsables de examinar o evaluar el
          contenido o la precisión y no garantizamos ni tendremos ninguna obligación o
          responsabilidad por los materiales o sitios web de terceros, o por cualquier otro
          material, producto o servicio de terceros.
          No somos responsables de ningún daño o perjuicio relacionado con la compra o el
          uso de bienes, servicios, recursos, contenido o cualquier otra transacción realizada
          en relación con sitios web de terceros. Revise cuidadosamente las políticas y
          prácticas de terceros y asegúrese de comprenderlas antes de realizar cualquier
          transacción. Las quejas, reclamos, inquietudes o preguntas sobre productos de
          terceros deben dirigirse al tercero.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 9 - COMENTARIOS DE USUARIO, RETROALIMENTACIÓN Y OTROS
          ENVIOS</SectionTitle>
          <Paragraph>
          Si, a nuestra solicitud, envía ciertas presentaciones específicas (por ejemplo,
          participaciones en un concurso) o sin una solicitud nuestra, envía ideas creativas,
          sugerencias, propuestas, planes u otros materiales, ya sea en línea, por correo
          electrónico, por correo postal o de otro modo. (colectivamente, 'comentarios'), usted
          acepta que podemos, en cualquier momento, sin restricciones, editar, copiar,
          publicar, distribuir, traducir y utilizar en cualquier medio cualquier comentario que
          nos envíe. No tenemos ni tendremos ninguna obligación (1) de mantener la
          confidencialidad de los comentarios; (2) pagar una compensación por cualquier
          comentario; o (3) para responder a cualquier comentario.
          Podemos, pero no tenemos la obligación de, monitorear, editar o eliminar contenido
          que determinemos, a nuestro exclusivo criterio, que es ilegal, ofensivo, amenazante, 
          calumnioso, difamatorio, pornográfico, obsceno o de otra manera objetable o que
          viole la propiedad intelectual de cualquier parte o estos Términos de servicio.
          Usted acepta que sus comentarios no violarán ningún derecho de terceros, incluidos
          los derechos de autor, marcas comerciales, privacidad, personalidad u otro derecho
          personal o de propiedad. Además, acepta que sus comentarios no contendrán
          material difamatorio o ilegal, abusivo u obsceno, ni contendrán ningún virus
          informático u otro malware que pueda afectar de alguna manera el funcionamiento
          del Servicio o cualquier sitio web relacionado. No puede utilizar una dirección de
          correo electrónico falsa, pretender ser otra persona que no sea usted mismo o
          engañarnos a nosotros o a terceros en cuanto al origen de los comentarios. Usted
          es el único responsable de los comentarios que haga y de su precisión. No
          asumimos ninguna responsabilidad por los comentarios publicados por usted o un
          tercero.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 10 - INFORMACIÓN PERSONAL</SectionTitle>
          <Paragraph>
          Su envío de información personal a través de la tienda se rige por nuestra Política
          de Datos Personales.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 11 - ERRORES, INEXACTITUDES Y OMISIONES</SectionTitle>
          <Paragraph>
          Ocasionalmente, puede haber información en nuestro sitio o en el Servicio que
          contenga errores tipográficos, inexactitudes u omisiones que puedan estar
          relacionadas con descripciones de productos, precios, promociones, ofertas, cargos
          de envío de productos, tiempos de tránsito y disponibilidad. Nos reservamos el
          derecho de corregir cualquier error, inexactitud u omisión, y de cambiar o actualizar
          la información o cancelar pedidos si alguna información en el Servicio o en cualquier
          sitio web relacionado es inexacta en cualquier momento sin previo aviso (incluso
          después de que haya enviado su pedido).
          No asumimos ninguna obligación de actualizar, modificar o aclarar la información en
          el Servicio o en cualquier sitio web relacionado, incluida, entre otros, la información
          de precios, excepto según lo exija la ley. No se debe tomar ninguna actualización
          específica o fecha de actualización aplicada en el Servicio o en cualquier sitio web
          relacionado para indicar que toda la información en el Servicio o en cualquier sitio
          web relacionado ha sido modificada o actualizada.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 12 - USOS PROHIBIDOS</SectionTitle>
          <Paragraph>
          Además de otras prohibiciones establecidas en los Términos de servicio, tiene prohibido usar el sitio o su contenido: (a) para cualquier propósito ilegal; (b) solicitar a
          otros que realicen o participen en actos ilícitos; (c) violar cualquier reglamento, regla,
          ley u ordenanza local internacional, federal, provincial o estatal; (d) infringir o violar
          nuestros derechos de propiedad intelectual o los derechos de propiedad intelectual
          de terceros; (e) acosar, abusar, insultar, dañar, difamar, calumniar, menospreciar,
          intimidar o discriminar por motivos de género, orientación sexual, religión, etnia,
          raza, edad, nacionalidad o discapacidad; (f) enviar información falsa o engañosa; (g) 
          cargar o transmitir virus o cualquier otro tipo de código malintencionado que se utilizará o se podrá utilizar de cualquier forma que afecte la funcionalidad o el funcionamiento del Servicio o de cualquier sitio web relacionado, otros sitios web o Internet;
          (h) para recopilar o rastrear la información personal de otros; (i) enviar spam, phishing, pharm, pretext, spider, crawl o scrape; (j) para cualquier propósito obsceno o
          inmoral; o (k) para interferir o eludir las características de seguridad del Servicio o
          cualquier sitio web relacionado, otros sitios web o Internet. Nos reservamos el derecho de terminar su uso del Servicio o cualquier sitio web relacionado por violar cualquiera de los usos prohibidos.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 13 - RENUNCIA DE GARANTÍAS; LIMITACIÓN DE RESPONSABILIDAD</SectionTitle>
          <Paragraph>
          No garantizamos, representamos ni garantizamos que su uso de nuestro servicio
          sea ininterrumpido, oportuno, seguro o libre de errores.
          No garantizamos que los resultados que puedan obtenerse del uso del servicio sean
          precisos o confiables.
          Usted acepta que de vez en cuando podemos eliminar el servicio por períodos de
          tiempo indefinidos o cancelar el servicio en cualquier momento, sin previo aviso.
          Usted acepta expresamente que el uso o la imposibilidad de usar el servicio es bajo
          su propio riesgo. El servicio y todos los productos y servicios que se le entregan a
          través del servicio se proporcionan (salvo que nosotros expresamente lo indiquemos) 'tal como están' y 'según estén disponibles' para su uso, sin ninguna representación, garantía o condición de ningún tipo, ya sea expresa o implícito, incluidas
          todas las garantías o condiciones implícitas de comerciabilidad, calidad comercial,
          idoneidad para un propósito particular, durabilidad, título y no infracción.
          En ningún caso Bicicletas JAVA Colombia, nuestros directores, funcionarios, empleados, afiliados, agentes, contratistas, pasantes, proveedores, prestadores de servicios o licenciatarios serán responsables de cualquier lesión, pérdida, reclamo o
          cualquier daño directo, indirecto, incidental, punitivo, especial o daños consecuentes
          de cualquier tipo, incluidos, entre otros, lucro cesante, pérdida de ingresos, pérdida
          de ahorros, pérdida de datos, costos de reemplazo o cualquier daño similar, ya sea
          por contrato, agravio (incluida la negligencia), responsabilidad estricta o de otro tipo,
          que surja de su el uso de cualquiera de los servicios o productos adquiridos mediante el servicio, o para cualquier otro reclamo relacionado de alguna manera con
          su uso del servicio o cualquier producto, incluidos, entre otros, cualquier error u omisión en cualquier contenido, o cualquier pérdida o daño de cualquier tipo incurrido
          como resultado del uso del servicio o cualquier contenido (o producto) publicado,
          transmitido o puesto a disposición a través del servicio, incluso si se advierte de su
          posibilidad. Debido a que algunos estados o jurisdicciones no permiten la exclusión
          o la limitación de responsabilidad por daños consecuentes o incidentales, en dichos
          estados o jurisdicciones, nuestra responsabilidad se limitará al máximo permitido por
          la ley colombiana.
          </Paragraph>
        </Section>


        <Section>
          <SectionTitle>SECCIÓN 14 - INDEMNIZACIÓN</SectionTitle>
          <Paragraph>
          Usted acepta indemnizar, defender y mantener indemne a Bicicletas JAVA Colombia y a nuestra matriz, subsidiarias, afiliadas, socios, funcionarios, directores, agentes, contratistas, otorgantes de licencias, proveedores de servicios, subcontratistas,
          proveedores, pasantes y empleados, indemnes de cualquier reclamo o demanda,
          incluidos los razonables, honorarios de abogados, hechos por un tercero debido a o
          que surjan de su incumplimiento de estos Términos de servicio o los documentos
          que incorporan por referencia, o su violación de cualquier ley o los derechos de un
          tercero.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 15 - DIVISIBILIDAD</SectionTitle>
          <Paragraph>
          En el caso de que se determine que alguna disposición de estos Términos de servicio es ilegal, nula o inaplicable, dicha disposición será, no obstante, ejecutable en la
          mayor medida permitida por la ley aplicable, y la parte inaplicable se considerará
          separada de estos Términos de Servicio, tal determinación no afectará la validez y
          aplicabilidad de cualquier otra disposición restante.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 16 - TERMINACIÓN</SectionTitle>
          <Paragraph>
          Las obligaciones y responsabilidades de las partes incurridas antes de la fecha de
          terminación sobrevivirán a la terminación de este acuerdo para todos los propósitos.
          Estos Términos de servicio son efectivos a menos que usted o nosotros los rescindamos. Puede rescindir estos Términos de servicio en cualquier momento notificándonos que ya no desea utilizar nuestros Servicios o cuando deje de utilizar nuestro
          sitio.
          Si, a nuestro exclusivo criterio, no cumple, o sospechamos que no ha cumplido con
          cualquier término o disposición de estos Términos de servicio, también podemos
          rescindir este acuerdo en cualquier momento sin previo aviso y usted seguirá siendo
          responsable de todos los montos adeudados. hasta e incluyendo la fecha de terminación; y / o, en consecuencia, puede denegarle el acceso a nuestros Servicios (o
          cualquier parte de estos).
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 17 - ACUERDO COMPLETO</SectionTitle>
          <Paragraph>
          El hecho de que no ejerzamos o hagamos cumplir cualquier derecho o disposición
          de estos Términos de servicio no constituirá una renuncia a dicho derecho o disposición.
          Estos Términos de servicio y cualquier política o regla operativa publicada por nosotros en este sitio o con respecto al Servicio constituyen el acuerdo completo y el entendimiento entre usted y nosotros y rigen su uso del Servicio, reemplazando cualquier acuerdo, comunicaciones y propuestas anteriores o contemporáneos, ya sea oral o escrito, entre usted y nosotros (incluidas, entre otras, las versiones anteriores de los Términos de servicio).
          Cualquier ambigüedad en la interpretación de estos Términos de servicio no se interpretará en contra del grupo de redacción.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 18 - LEY APLICABLE</SectionTitle>
          <Paragraph>
          Estos Términos de servicio y cualquier acuerdo separado mediante el cual le proporcionemos Servicios se regirán e interpretarán de acuerdo con las leyes del estado colombiano.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 19 - CAMBIOS EN LOS TÉRMINOS DE SERVICIO</SectionTitle>
          <Paragraph>
          Puede revisar la versión más actualizada de los Términos de servicio en cualquier
          momento en esta página.
          Nos reservamos el derecho, a nuestro exclusivo criterio, de actualizar, cambiar o
          reemplazar cualquier parte de estos Términos de servicio mediante la publicación
          de actualizaciones y cambios en nuestro sitio web. Es su responsabilidad revisar
          nuestro sitio web periódicamente para ver si hay cambios. Su uso continuo o acceso
          a nuestro sitio web o al Servicio después de la publicación de cualquier cambio en
          estos Términos de servicio constituye la aceptación de dichos cambios.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 20 – GARANTIA</SectionTitle>
          <Paragraph>
          Bicicletas JAVA Colombia ofrecemos garantía de tres (3) meses por defectos de
          fábrica.
          ¿Puedo solicitar devolución de dinero? Tu dinero solo será devuelto en los casos de
          retracto de la compra (Artículo 47) y derecho a la reversión de compra (Artículo 51),
          bajo los plazos y condiciones estipulados por la ley 1480 de 2011, que podrás
          consultar líneas abajo. Para el caso de retracto, el producto debe estar
          completamente nuevo, sin marcas de uso. Los costos de envío correrán por cuenta
          del comprador. En los casos que no aplique ninguna de las dos leyes mencionadas
          bajo ninguna circunstancia se realizará devolución de dinero, pero puedes estar
          tranquilo ya que se realizará el respectivo cambio o garantía del producto. Estamos
          para brindarte apoyo y soluciones en tus compras. 
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>SECCIÓN 21 – CAMBIOS</SectionTitle>
          <Paragraph>
          ¿Puedo realizar Cambios? Si, Para efectuar cualquier tipo de cambio, reclamación
          o garantía debes presentar tu factura o comprobante de pago. Para el caso de
          cambios el producto debe estar completamente nuevo, sin marcas de uso. Los
          costos de envío correrán por cuenta del comprador.
          Al realizar tu compra se aceptan automáticamente todas las condiciones
          mencionadas anteriormente estipuladas por Bicicletas JAVA Colombia by Global
          Eco Business SAS.
          </Paragraph>
        </Section>

        <Section>
          <Paragraph>
          El Derecho Reversión de pago establecido en el artículo 51 de la Ley 1480 de 2011:
          <a href="https://leyes.co/el_estatuto_del_consumidor/51.htm" style={{textDecoration: "none", width: "full", display: "block"}}><Highlight>https://leyes.co/el_estatuto_del_consumidor/51.htm</Highlight></a>
          </Paragraph>
        </Section>

      </ContentWrapper>
    </PageContainer>

    <div style={{backgroundColor: "#121212"}}>
    <Footer />

    </div>

    </>
  );
};

export default TerminosYCondiciones;

